import React, { useState, useCallback } from 'react';
import InfoBarAccordionItem from './components/InfoBarAccordionItem';

import './InfoBarAccordion.scss';

function InfoBarAccordion({ offers, config }) {
  const [expandedOfferIndex, setExpandedOfferIndex] = useState(0);
  const { tagHelper } = config;

  const handleRef = useCallback((ref) => {
    tagHelper(ref); // handle Chase tagging implementation
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandedOfferIndex]);

  const handleClick = index => (event) => {
    const isCurrentOfferCollapsed = expandedOfferIndex !== index;

    if (isCurrentOfferCollapsed) {
      event.preventDefault();

      // Set the accurate width of the description while animating to avoid text jumps
      const expandedDescription = document.querySelector('.mn_infoBar .mn_offer.mn_expanded .mn_description');
      const collapsedDesription = event.currentTarget.querySelector('.mn_description');
      collapsedDesription.style.minWidth = `${expandedDescription.clientWidth}px`;
      // Delete the forced width after the animation is completed
      setTimeout(() => { collapsedDesription.style.minWidth = ''; }, 800);

      setExpandedOfferIndex(index);
    }
  };

  return (
    <div className="mn_offersAccordionWrapper" ref={handleRef}>
      {offers.map((offer, index) => (
        <InfoBarAccordionItem
          isSingle={offers.length === 1}
          isExpanded={index === expandedOfferIndex}
          key={offer.dealId}
          offer={offer}
          config={config}
          handleClick={handleClick(index)}
        />
      ))}
    </div>
  );
}

export default InfoBarAccordion;
